var Chart = require('chart.js/dist/chart')

class ExtendedRadialLinearScale extends Chart.RadialLinearScale {
    /**
     * @protected
     */
    drawGrid() {
        var display = this.options.angleLines.display;
        this.options.angleLines.display = false;

        Chart.RadialLinearScale.prototype.drawGrid.call(this);

        this.options.angleLines.display = display;

        const me = this;
        const parent = Chart.RadialLinearScale.prototype;
        const ctx = me.ctx;
        const opts = me.options;
        const {angleLines, grid} = opts;
        const labelCount = me.getLabels().length;

        let i, offset, position;

        if (display) {

            ctx.save();
            for (i = me.getLabels().length - 1; i >= 0; i--) {

                const optsAtIndex = angleLines.setContext(me.getContext(i));
                const {color, lineWidth} = optsAtIndex;
                if (!lineWidth || !color) {
                    continue;
                }

                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = color;
                ctx.setLineDash(optsAtIndex.borderDash);
                ctx.lineDashOffset = optsAtIndex.borderDashOffset;

                // we have padded the labels at the top and bottom to stop them overlapping
                // so we also need to extend these lines to match
                // 0.5 is because we've offset the chart start by 1/2 a segment
                var padding = 4 + (1.75 * Math.pow(Math.abs(((i + 0.5) % (labelCount / 2)) - (labelCount / 4)), 1.7));

                offset = me.getDistanceFromCenterForValue(opts.ticks.reverse ? me.min : me.max + padding);
                position = me.getPointPosition(i, offset);
                ctx.beginPath();
                ctx.moveTo(me.xCenter, me.yCenter);
                ctx.lineTo(position.x, position.y);
                ctx.stroke();


            }
            ctx.restore();

        }
    }
}

ExtendedRadialLinearScale.id = 'ExtendedRadialLinearScale';
Chart.register(ExtendedRadialLinearScale);

Chart.register({
    id: 'segmentedBackgroundPlugin',
    beforeDraw: (chart, args, options) => {
        if (chart.config.type == 'radar') {

            const {ctx, scales, config} = chart
            const {xCenter, yCenter, drawingArea: radius} = scales.r

            // canvas works in radians, chartjs in degrees
            const segmentsize = (scales.r.options.startAngle * 2 * Math.PI / 180);

            // chartjs renders from 12oclock, canvas from 3 o clock.
            // plus we have an offset to account for
            const offset = (Math.PI) / 2 - (segmentsize / 2);


            config.data.datasets.forEach(dataset => {
                if (dataset.segmentBackground) {
                    ctx.save();

                    ctx.beginPath();
                    ctx.moveTo(xCenter, yCenter);
                    ctx.arc(xCenter, yCenter, radius, (dataset.startSegment * segmentsize) - offset, (dataset.endSegment * segmentsize) - offset);
                    // ctx.rect(xCenter, yCenter, 50, 50)
                    ctx.fillStyle = dataset.segmentBackground;

                    ctx.fill()
                    ctx.restore()
                }
            });
        }


    }
});

if (typeof (config) != 'undefined') {
    var radarChart = new Chart(
        document.getElementById("radar_chart"),
        config
    );
}


if (typeof (gaugeConfig) != 'undefined') {
    var gaugeChart = new Chart(
        document.getElementById("gauge_chart"),
        gaugeConfig
    );
}
